import './App.css';
import CentralRoute from './core/CentralRoute';

function App() {
  return (
    <CentralRoute />
  );
}

export default App;
